<template>
    <div>
        <div class="border-grayxlight border-b text-sm semibold text-darkgray mb-2">Основные данные</div>
        <div class="flex relative">
            <div class="flex-1 pr-4" v-if="edit">
                <base-input v-model="lastName" class="mb-1" max-length="20" @input="validation">Фамилия</base-input>
                <base-input v-model="firstName" class="mb-1" max-length="20" @input="validation">Имя</base-input>
                <base-input v-model="middleName" max-length="20" class="mb-1">Отчество</base-input>
            </div>

            <div class="flex-1 pr-4" v-else>
                <EmployeeDataItem label="Фамилия" :value="lastName" />
                <EmployeeDataItem label="Имя" :value="firstName" />
                <EmployeeDataItem label="Отчество" :value="middleName" v-if="middleName" />
            </div>

            <div class="flex-1 pr-4" v-if="edit">
                <phone-input v-model="phone" class="mb-1">Телефон</phone-input>
                <base-input v-model="email" max-length="50" class="mb-1" @input="validation">E-mail</base-input>
            </div>

            <div class="flex-1 pr-4" v-else>
                <EmployeeDataItem label="Телефон" :value="phone" />
                <EmployeeDataItem label="E-mail" :value="email" />
                <EmployeeDataItem label="Табельный код" :value="employment.employee_tabel_code" />
                <!-- <EmployeeDataItem label="Статус" :value="isActive" /> -->
            </div>
            <div v-if="!edit" class="absolute right-0 top-0 text-xs cursor-pointer text-graylight" @click="change">
                Изменить
            </div>
        </div>
        <div class="pt-3 text-right" v-if="edit">
            <btn @click="save" :disabled="isDisabled" :class="{ 'opacity-50': isDisabled }">Сохранить</btn>
            <btn class="ml-3" type="secondary" @click="cancel">Отмена</btn>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import EmployeeDataItem from './EmployeeDataItem.vue'
import { useEmploymentStore } from '@/stores/employmentStore'
import { User } from '@/types'

interface Props {
    employment: {
        id: string,
        employee_tabel_code: string,
        user: User,
    }
}
const emit = defineEmits(['cancel'])
const store = useEmploymentStore()
let { employment } = defineProps<Props>()
// const isActive = employment.user?.is_active ? 'Доступен' : 'Не доступен'
const edit = ref(false)
const isDisabled = ref(true)
const email = ref(employment.user.email)
const phone = ref(employment.user.phone)
const firstName = ref(employment.user.first_name)
const lastName = ref(employment.user.last_name)
const middleName = ref(employment.user.middle_name)

const validation = () => {
    const re = /^[A-Z0-9._%+-]+@[A-Z0-9-]+.+.[A-Z]{2,4}$/i
    if (firstName.value.length > 1 &&
        lastName.value.length > 1 &&
        re.test(email.value)) {
        isDisabled.value = false
    } else {
        isDisabled.value = true
    }
}

const save = async () => {
    let data = {}
    if(phone.value !== employment.user.phone) {
        data = {
        first_name: firstName.value,
        last_name: lastName.value,
        middle_name: middleName.value,
        user: {
            email: email.value,
            phone: phone.value
        }
    }}
    else {
        data = {
        first_name: firstName.value,
        last_name: lastName.value,
        middle_name: middleName.value,
        user: {
            email: email.value
        }
    }}
    await store.userEdit(employment.user.id, data)
    await store.fetchEmployment(employment.id)
    edit.value = false
}

const change = () => {
    validation()
    edit.value = true
}

const cancel = () => {
    edit.value = false
    emit('cancel')
}

</script>
